var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmail = function SvgEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    fillRule: "nonzero",
    d: "M21.984 4c.25 0 .5.047.75.14.844.314 1.266.94 1.266 1.878v12.011c0 .22-.047.454-.14.704-.344.845-.97 1.267-1.876 1.267H2.016c-.25 0-.5-.047-.75-.14C.422 19.545 0 18.935 0 18.03V6.017c0-.25.047-.5.14-.751C.454 4.422 1.079 4 2.017 4h19.968zM7.266 14.463c.25-.187.312-.422.187-.703-.187-.25-.422-.313-.703-.188l-3.516 2.017c-.25.188-.312.407-.187.657.094.157.25.25.469.282.03 0 .109-.031.234-.094l3.516-1.97zM12 14.51a.504.504 0 0 0 .281-.094l8.485-5.49c.218-.187.265-.422.14-.703-.187-.22-.406-.266-.656-.14L12 13.43 3.75 8.082c-.25-.156-.469-.11-.656.14-.125.282-.078.517.14.705l8.485 5.49c.062.03.156.062.281.093zm8.953 1.736c.125-.25.063-.469-.187-.657l-3.516-2.017c-.281-.125-.516-.063-.703.188-.125.281-.063.516.187.703l3.516 1.971c.094.031.172.063.234.094a.74.74 0 0 0 .47-.282z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email.96612a50.svg";
export { ForwardRef as ReactComponent };